<mat-chip-listbox [ngClass]="{ 'small-chip-list': size === 'sm' }">
  <mat-chip
    *ngFor="let tag of tags; trackBy: trackByTag"
    [style.background-color]="tag.hexColour"
    [style.--mdc-chip-label-text-color]="tag | tagTextColour"
  >
    {{ tag.name }}
  </mat-chip>
</mat-chip-listbox>
